
import Vue, { PropType } from 'vue';
import PlayerStateRepository from '@/core/player-state';

export default Vue.extend({
    name: 'Loading',

    props: {
        playerStateRepository: {
            type: Object as PropType<PlayerStateRepository>,
            required: true
        }
    },

    computed: {
        show() {
            return (this.playerStateRepository as PlayerStateRepository).state?.playback?.isStuck;
        }
    }
});
